import { ShoesState } from 'src/types'
import { gripHeal, gripMiddle, gripRightBack, gripTop, gripWarts } from './runningShoesSole'

export const artificialTurfSole = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  ctx.save()
  ctx.rotate(0)
  ctx.strokeStyle = '#1c1c1c'
  ctx.fillStyle = 'white'
  ctx.beginPath()
  ctx.moveTo(10, 431) //つま先＿左下
  ctx.quadraticCurveTo(5, 443, 13, 458)
  ctx.quadraticCurveTo(47, 480, 109, 499)
  ctx.quadraticCurveTo(119, 513, 119, 513)
  ctx.quadraticCurveTo(131, 512, 137, 518)
  ctx.quadraticCurveTo(136, 509, 149, 511)
  ctx.quadraticCurveTo(166, 520, 221, 529)
  ctx.quadraticCurveTo(227, 540, 227, 540)
  ctx.quadraticCurveTo(240, 530, 246, 543)
  ctx.quadraticCurveTo(249, 532, 268, 535)
  ctx.quadraticCurveTo(348, 543, 348, 543)
  ctx.quadraticCurveTo(358, 550, 377, 543)
  ctx.quadraticCurveTo(386, 545, 411, 538)
  ctx.quadraticCurveTo(431, 544, 438, 538)
  ctx.quadraticCurveTo(449, 541, 465, 540)
  ctx.quadraticCurveTo(499, 545, 499, 545)
  ctx.quadraticCurveTo(593, 540, 593, 540)
  ctx.quadraticCurveTo(603, 536, 613, 543)
  ctx.quadraticCurveTo(772, 544, 772, 544)
  ctx.quadraticCurveTo(784, 540, 790, 545)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.quadraticCurveTo(826, 548, 853, 533) // 右下
  ctx.quadraticCurveTo(855, 517, 855, 517)
  ctx.quadraticCurveTo(850, 507, 857, 502)
  ctx.quadraticCurveTo(861, 500, 857, 493)
  // ctx.quadraticCurveTo(854, 487, 855, 481)
  ctx.quadraticCurveTo(849, 483, 855, 478) // 右上
  ctx.quadraticCurveTo(845, 476, 841, 476)
  ctx.quadraticCurveTo(702, 497, 548, 488)
  ctx.quadraticCurveTo(449, 486, 391, 500)
  ctx.quadraticCurveTo(280, 520, 203, 500)
  ctx.quadraticCurveTo(89, 478, 10, 431)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 2.0
  ctx.beginPath()
  ctx.moveTo(15, 447) //
  ctx.quadraticCurveTo(110, 500, 225, 519)
  ctx.quadraticCurveTo(304, 534, 368, 515)
  ctx.quadraticCurveTo(396, 501, 451, 497)
  ctx.stroke()

  ctx.lineWidth = 1.5
  ctx.moveTo(404, 540)
  ctx.quadraticCurveTo(432, 511, 483, 505)
  ctx.quadraticCurveTo(543, 499, 597, 508)
  ctx.moveTo(429, 541)
  ctx.quadraticCurveTo(460, 499, 578, 517)
  ctx.moveTo(458, 540)
  ctx.quadraticCurveTo(485, 509, 560, 524)

  ctx.moveTo(583, 502)
  ctx.quadraticCurveTo(729, 507, 858, 494)

  ctx.lineWidth = 0.8
  ctx.moveTo(582, 510)
  ctx.quadraticCurveTo(699, 520, 858, 512)
  ctx.moveTo(582, 520)
  ctx.quadraticCurveTo(683, 539, 854, 529)

  ctx.stroke()
  ctx.closePath()

  gripTop(ctx, 0, 0)
  gripMiddle(ctx, 0, 0)
  gripRightBack(ctx, 0, 0)
  gripHeal(ctx, 0, -30)

  // gripToe(ctx, 0, 0)
  gripWarts(ctx, 0, 0)
  gripWarts(ctx, 15, 9)
  gripWarts(ctx, 30, 16)
  gripWarts(ctx, 45, 23)
  gripWarts(ctx, 63, 29)
  gripWarts(ctx, 80, 34)

  gripWarts(ctx, 114, 42)
  gripWarts(ctx, 133, 48)
  gripWarts(ctx, 157, 53)
  gripWarts(ctx, 178, 56)

  gripWarts(ctx, 225, 60)
  gripWarts(ctx, 250, 63)
  gripWarts(ctx, 275, 64)
  gripWarts(ctx, 300, 65)

  gripWarts(ctx, 359, 62)
  gripWarts(ctx, 382, 62)
  gripWarts(ctx, 405, 62)
  gripWarts(ctx, 428, 62)
  gripWarts(ctx, 451, 62)

  gripWarts(ctx, 482, 68)
  gripWarts(ctx, 499, 68)
  gripWarts(ctx, 520, 69)
  gripWarts(ctx, 540, 67)

  gripWarts(ctx, 583, 67)
  gripWarts(ctx, 605, 68)
  gripWarts(ctx, 627, 67)
  gripWarts(ctx, 649, 68)
  gripWarts(ctx, 671, 69)
  gripWarts(ctx, 693, 71)
  gripWarts(ctx, 715, 72)
  gripWarts(ctx, 737, 72)
  gripWarts(ctx, 759, 74)
  gripWarts(ctx, 781, 74)

  ctx.restore()
}
